export default __webpack_public_path__ + "static/media/cardTokenBg.14dbfbdb.png";